import React from "react";
import Routes from "./Routes";
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'sonner';
import DemoModeToast from './components/DemoModeToast';

function App() {
  return (
    <LanguageProvider>
      <Routes />
      <DemoModeToast />
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
        toastOptions={{
          style: { fontFamily: 'inherit' },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
